import { z } from 'zod';
/**
 * OAuth 提供者數據 Schema
 * 用於 accounts.providerData，儲存 OAuth 提供者返回的額外資訊
 * 不同提供者（Google, LINE, Email）可能有不同的數據結構
 */
export const ProviderDataSchema = z
    .record(z.string(), z.any())
    .nullable()
    .optional()
    .describe('OAuth 提供者數據（JSONB 格式）');
